module.exports = __webpack_public_path__ + "static/media/how-it-works-4.6754f83e.png";